// Resolve `/` to a real organization membership: the remembered organization
// when it is still present, the only organization when there is one, or the
// organization directory.

import { Navigate } from "react-router-dom";
import { LoadingRegion } from "@/components/ui/loading";
import { QueryFailure } from "@/components/StudioPrimitives";
import { recallWorkspace } from "@/lib/workspace/lastWorkspace";
import { createWorkspaceLinks, DIRECTORY_PATH } from "@/lib/workspace/paths";
import { useWorkspaces } from "@/lib/workspace/queries";

export function WorkspaceEntryScreen() {
  const workspaces = useWorkspaces();

  if (workspaces.isPending) {
    return <LoadingRegion label="Finding your organizations…" />;
  }
  if (workspaces.isError) {
    return (
      <QueryFailure
        error={workspaces.error}
        retry={() => void workspaces.refetch()}
        title="Your organizations could not be loaded."
      />
    );
  }

  const remembered = recallWorkspace();
  const target =
    workspaces.data.find((workspace) => workspace.slug === remembered) ??
    (workspaces.data.length === 1 ? workspaces.data[0] : undefined);

  if (!target) return <Navigate to={DIRECTORY_PATH} replace />;
  return <Navigate to={createWorkspaceLinks(target.slug).home} replace />;
}
